import { Button, Spinner, TextInput } from 'flowbite-react';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import showToast from '../../../components/CustomToast/toastHelper';
import client from '../../../api/client';
import CustomModal from '../../../components/Modal/CustomModal';
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from '../../../assets/Ideos.png'


interface ValidatePaymentProps {
    payload: any;
    closeVerificationModal: () => void;
}

const ValidatePaymentModal = ({ payload, closeVerificationModal }: ValidatePaymentProps) => {

    const navigate = useNavigate();
    const [otp, setOtp] = useState<string[]>(['', '', '', '']);
    const [loading, setLoading] = useState<boolean>(false);
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
    const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false);
    const [transactionId, setTransactionId] = useState<any>(1);
    const [showOtp, setShowOtp] = useState<boolean>(false)

    const handleSuccessfulPayment = () => {
        // closeVerificationModal()
        setOpenDetailsModal(true)
        setTimeout(() => {
            navigate("/bills-payment/history")
        }, 4000)
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const { value } = e.target;
        if (value.length > 1 || isNaN(Number(value))) return; // Only accept one digit and numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Focus the next input if a value is entered
        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            // Move to the previous input if current is empty and backspace is pressed
            inputRefs.current[index - 1]?.focus();
        }
    };

    const verifyPayment = async () => {
        const data = {
            ...payload,
            pin: otp.join(''),
        };

        if (payload.billCategoryId != 4 && payload.amount < 100) {
            showToast('Amount cannot be less than 100 naira', 'error');
            return;
        }

        setLoading(true);

        try {
            const response = await client.post(`/subsidiary/dashboard/bills-payment/transaction/validate`, data);
            showToast(response.data.message, 'success');
            setTransactionId(response.data.data.id);
            handleSuccessfulPayment()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                showToast(message, 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 bg-white rounded-lg max-w-sm mx-auto">
            <p className="text-lg font-semibold text-center">Verify Transaction</p>
            <p className="text-sm text-center text-gray-600 mb-6">Please enter your four-digit pin to verify this transaction</p>

            <div className="flex justify-center mb-2">
                <div className="flex gap-3">
                    {otp.map((digit, index) => (
                        <TextInput
                            key={index}
                            type={showOtp ? 'text' : 'password'}
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)} // Set refs for each input
                            className="w-12 text-center text-xl font-bold border border-gray-300 rounded-lg focus:border-blue-500"
                        />
                    ))}
                </div>
            </div>

            {/* Toggle Visibility */}
            <div className="flex justify-center items-center mb-2">
                <button type="button" onClick={() => setShowOtp(!showOtp)} className="p-2 w-8 h-8 flex items-center justify-center rounded-md">
                    {showOtp ? <FaEyeSlash className="w-6 h-6 text-gray-600" /> : <FaEye className="w-6 h-6 text-gray-600" />}
                </button>
            </div>

            <div className="my-4">
                <Button
                    onClick={verifyPayment}
                    className="bg-custom-button-green w-full py-2 text-white text-lg rounded-md"
                >
                    {loading ? <Spinner size="sm" /> : 'Verify Transaction'}
                </Button>
            </div>

            <CustomModal
                show={openDetailsModal}
                icon=""
                dismissible
                onClose={() => setOpenDetailsModal(false)}
                size="md"
            >
                <PaymentSummaryModal
                    billPaymentId={transactionId} // Pass the transaction ID to the summary modal
                    onclose={() => setOpenDetailsModal(false)} // Close the summary modal when needed
                />
            </CustomModal>

            {loading && (
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                </div>
            )}
        </div>
    );
};

export default ValidatePaymentModal;
